export class UserPermissionsResponse {
  data: any[];
  total: number;
  count: number;
  page: number;
  pageCount: number;
}
